import type { AcademyAnnouncementBanner } from '~/generated_types';
import type { AcademyAnnouncementBannerThemeSettings } from '../../types';
import { queryClient, useDefaultMutation } from '~/lib/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { academyAnnouncementBannerKeys } from './academyAnnouncementBannerKeyFactory';

export interface UpdateAcademyAnnouncementBannerParams {
  id: string;
  title?: string;
  startTime?: number | null;
  endTime?: number | null;
  themeSettings?: AcademyAnnouncementBannerThemeSettings;
}

export function updateAcademyAnnouncementBanner(
  academyId: string,
  { id, ...params }: UpdateAcademyAnnouncementBannerParams,
): Promise<AcademyAnnouncementBanner['ADMIN']> {
  return FetchPromise.put(`academies/${academyId}/academy_announcement_banners/${id}`, params);
}

export function useUpdateAcademyAnnouncementBannerMutation(academyId: string) {
  return useDefaultMutation(
    (params: UpdateAcademyAnnouncementBannerParams) => updateAcademyAnnouncementBanner(academyId, params),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(academyAnnouncementBannerKeys.root);
      },
    },
  );
}
